export default function Rex() {
  return <div className="img-wrapper rex" rex></div>;
}
